import { CreatePlanInput, CreatePlanResponse, PlanResponse, PlansResponse } from '../types/plan.types';
import http from '../utils/http-common';

const createPlan = (data: CreatePlanInput) => {
  return http.post<CreatePlanResponse>('/admin/plan/create-plan', data);
};

const getPlans = () => {
  return http.get<PlansResponse>('/admin/plan/get-plans');
};

const getPlansById = (id: string) => {
  return http.post<PlanResponse>('/admin/plan/get-plan', {planId: id});
};

const updatePlan = (data: CreatePlanInput) => {
  return http.post<PlanResponse>('/admin/plan/update-plan', data);
};

const PlansService = {
  createPlan,
  getPlans,
  getPlansById,
  updatePlan
};

export default PlansService;
